










































import { mapState } from 'vuex';
import { EdexAuth } from '@adobe/edex/ui/shared/config/auth';
import * as memberAPI from '@adobe/edex/frontend/api/member';
import { AdobeAnalyticsEvent } from '@adobe/edex/ui/shared/constants';
import { Analytics } from '@adobe/edex/ui/shared/config/analytics';
import Vue from 'vue';
import { $t } from '@adobe/edex/ui/shared/config/i18n';
enum MemberFollow {
  memberFollowingExceeded = 'member-follow-limit-exceeded'
}
export default {
  props: ['targetMember', 'wide'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onUnfollow(id) {
      this.loading = true;
      await memberAPI.unfollow(id);
      // TODO: reenable this rule
      // eslint-disable-next-line vue/no-mutating-props
      this.targetMember.followed = false;
      this.loading = false;
    },
    async onFollow(member) {
      if (!this.member.id) {
        await EdexAuth.signIn();
      }
      this.loading = true;
      Analytics.getInstance().emitEvent(AdobeAnalyticsEvent.follow, 'Follow member');
      try {
        await memberAPI.follow(member.id);
      } catch(e) {
        this.loading = false;
        if(e?.response?.data?.details?.errorcode === MemberFollow.memberFollowingExceeded) {
          Vue.toasted.error($t(e?.response?.data?.message));
          return;
        } else {
          throw e;
        }
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.targetMember.followed = true;
      this.loading = false;
    },
  },
  computed: {
    ...mapState('member', ['member']),
    show() {
      return this.member && this.member.id !== this.targetMember.id;
    },
  },
};
